import { useState, useEffect } from 'react';
import { getCompanyContext } from 'utils/setCompanyContext';

/**
 * Hook para obter a empresa atual selecionada
 * @returns {Object} { currentCompany, loading }
 */
export function useCurrentCompany() {
  const [currentCompany, setCurrentCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCurrentCompany = () => {
      try {
        const context = getCompanyContext();
        if (context && context.companies && context.companies.length > 0) {
          setCurrentCompany(context.companies[0]);
        } else {
          // Fallback para MOV Fibra se não houver contexto
          setCurrentCompany({
            id: 1,
            name: 'MOV Fibra',
            slug: 'mov-fibra'
          });
        }
      } catch (error) {
        console.warn('Erro ao carregar empresa atual:', error);
        setCurrentCompany({
          id: 1,
          name: 'MOV Fibra',
          slug: 'mov-fibra'
        });
      } finally {
        setLoading(false);
      }
    };

    loadCurrentCompany();

    // Listener para mudanças na empresa selecionada
    const handleCompanyChange = (event) => {
      if (event.detail && event.detail.company) {
        setCurrentCompany(event.detail.company);
      }
    };

    window.addEventListener('company-changed', handleCompanyChange);

    return () => {
      window.removeEventListener('company-changed', handleCompanyChange);
    };
  }, []);

  return { currentCompany, loading };
}

